interface LeadData {
  nombre: string
  email: string
  rut: string
  score: number | null
  probabilidad: string | null
  timestamp: string
  source: string
}

interface EventData {
  event_name: string
  email: string
  rut: string
  score: number | null
  probabilidad: string | null
  timestamp: string
}

export function saveLead(data: {
  nombre: string
  email: string
  rut: string
  score?: number
  probabilidad?: string
}): void {
  try {
    const leads: LeadData[] = JSON.parse(
      localStorage.getItem('rentual_leads') || '[]',
    )
    const lead: LeadData = {
      nombre: data.nombre,
      email: data.email,
      rut: data.rut,
      score: data.score ?? null,
      probabilidad: data.probabilidad ?? null,
      timestamp: new Date().toISOString(),
      source: 'rentual_form',
    }
    leads.push(lead)
    localStorage.setItem('rentual_leads', JSON.stringify(leads))
    console.log('[Rentual] Lead saved:', lead)
  } catch (e) {
    console.error('[Rentual] Error saving lead:', e)
  }
}

export function trackEvent(data: {
  event_name: string
  email?: string
  rut?: string
  score?: number
  probabilidad?: string
}): void {
  try {
    const events: EventData[] = JSON.parse(
      localStorage.getItem('rentual_events') || '[]',
    )
    const event: EventData = {
      event_name: data.event_name,
      email: data.email || '',
      rut: data.rut || '',
      score: data.score ?? null,
      probabilidad: data.probabilidad ?? null,
      timestamp: new Date().toISOString(),
    }
    events.push(event)
    localStorage.setItem('rentual_events', JSON.stringify(events))
    console.log('[Rentual] Event tracked:', event)
  } catch (e) {
    console.error('[Rentual] Error tracking event:', e)
  }
}
